<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="スケジュールのリセットが必要です"
        ok-title="リセットする"
        ok-variant="yokumiru-orange"
        cancel-title="キャンセル"
        cancel-variant="yokumiru-gray"
        @ok="confirm"
        @hidden="close">
        <template v-if="isUserSummerTime">
            <p class="mt-3 mb-0">冬時間中に登録された基本スケジュールが存在します。</p>
            <p>サマータイムのスケジュールとして登録するため、現在登録中の基本スケジュールはリセットされます。</p>
        </template>
        <template v-else>
            <p class="mt-3 mb-0">サマータイム期間中に登録された基本スケジュールが存在します。</p>
            <p>冬時間のスケジュールとして登録するため、現在登録中の基本スケジュールはリセットされます。</p>
        </template>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                inProgress: false,
                timezoneObj: null,
                isDeviceScheduleTimezone: false,
                isUserSummerTime: false,
            };
        },

        created: function() {
            bus.$on('open-modal-doctor-timezone-dst-confirm', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-timezone-dst-confirm')
        },

        methods: {
            open: function (timezoneObj, isDeviceScheduleTimezone) {
                this.timezoneObj = timezoneObj
                this.isDeviceScheduleTimezone = isDeviceScheduleTimezone
                this.isUserSummerTime = this.helper.isUserSummerTimeNow(timezoneObj.value)
                this.modalShow = true
            },

            close: function () {
                this.modalShow = false
            },

            confirm: async function (e) {
                e.preventDefault()
                if (this.inProgress) return
                this.inProgress = true

                const params = {
                    schedule_timezone: this.timezoneObj.key,
                    is_device_schedule_timezone: this.isDeviceScheduleTimezone,
                    is_basic_only: true,
                }

                await axios.post(constants.doctor.schedules.endpoint.deleteAll, params)
                    .then(() => {
                        bus.$emit('alert-success', 'スケジュールをリセットしました。')
                        bus.$emit('schedule-timezone-confirmed')
                        this.close()
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },
        },
    }
</script>
